

import { renderToString } from 'preact-render-to-string';
import { MwlIcons } from "../components/MwlIcons";
import { initializeMapInContainer } from './utils';
import i18n from '@i18n';

import { state } from './context';

export const initMapFunctionality = (lightbox) => {
  const mapIcon = <MwlIcons icon={'map'} />;
  const imageIcon = <MwlIcons icon={'image'} />;

  const updateButton = (el) => {
    el.innerHTML = state.isMapView ? renderToString(imageIcon) : renderToString(mapIcon);
    el.dataset.tooltip = state.isMapView ? i18n.TOOLBAR.SHOW_IMAGE : i18n.TOOLBAR.SHOW_ON_MAP;
  };

  const toggleShowHideButton = (show) => {
    const mapButton = document.querySelector('.pswp__button--map-button');
    if (mapButton) {
      mapButton.style.display = show ? 'flex' : 'none';
    }
  };

  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'map-button',
      ariaLabel: i18n.TOOLBAR.SHOW_ON_MAP,
      order: 11,
      isButton: true,
      html: renderToString(mapIcon),
      onInit: (el) => {
        el.dataset.tooltip = i18n.TOOLBAR.SHOW_ON_MAP;
      },
      onClick: (event, el) => {
        const currSlide = lightbox.pswp.currSlide;
        state.isMapView = !state.isMapView;

        if (state.isMapView) {
          // If the image is zoomed in, let's zoom out first
          currSlide.zoomTo(0, { x: 0, y: 0 }, 0);

          // Hide the metadata
          const metadata = document.querySelector('.mwl__metadata');
          if (metadata) { metadata.style.display = 'none'; }

          const overlayDiv = document.createElement('div');
          overlayDiv.id = 'map-overlay';
          overlayDiv.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999;';
          
           // Get the #pswp__items transform translate3D X value and apply it to the overlay
           const transform = document.querySelector('#pswp__items').style.transform;
           let translateX = transform.match(/translate3d\(([^,]+),/)[1];
 
           // Invert the translateX value
           if (translateX.startsWith('-')) {
             translateX = translateX.substring(1);
           } else {
             translateX = `-${translateX}`;
           }
 
           overlayDiv.style.transform = `translate3d(${translateX}, 0, 0)`;

          ['pointerdown', 'pointermove', 'pointerup', 'touchstart', 'touchmove', 'touchend'].forEach(eventType => {
            overlayDiv.addEventListener(eventType, e => e.stopPropagation());
          });

          const mapContainer = document.createElement('div');
          mapContainer.id = 'map-container';
          
          const maxWidth = window.innerWidth;
          const maxHeight = window.innerHeight;
          
          const widthRatio = currSlide.width / maxWidth;
          const heightRatio = currSlide.height / maxHeight;
          const scaleFactor = Math.max(widthRatio, heightRatio);

          if ( scaleFactor > 1 ) {
            mapContainer.style.width = (currSlide.width / scaleFactor) + 'px';
            mapContainer.style.height = (currSlide.height / scaleFactor) + 'px';
          } else {
            mapContainer.style.width = currSlide.width + 'px';
            mapContainer.style.height = currSlide.height + 'px';
          }
          
          // Center the container
          mapContainer.style.position = 'absolute';
          mapContainer.style.top = '50%';
          mapContainer.style.left = '50%';
          mapContainer.style.transform = 'translate(-50%, -50%)';


          overlayDiv.appendChild(mapContainer);
          lightbox.pswp.container.appendChild(overlayDiv);

          initializeMapInContainer('map-container', currSlide.data);
        } else {
          // Show the metadata
          const metadata = document.querySelector('.mwl__metadata');
          if (metadata) { metadata.style.display = 'block'; }

          // Remove the overlay
          const overlayDiv = document.getElementById('map-overlay');
          if (overlayDiv) overlayDiv.remove();
        }

        updateButton(el);
      },
    });
  });

  lightbox.on('change', () => {

    toggleShowHideButton(true);

    if (state.isMapView) {
      state.isMapView = false;
      // Show the metadata
      const metadata = document.querySelector('.mwl__metadata');
      if (metadata) { metadata.style.display = 'block'; }

      // Remove the overlay
      const overlayDiv = document.getElementById('map-overlay');
      if (overlayDiv) overlayDiv.remove();
      
      const mapButton = document.querySelector('.pswp__button--map-button');
      if (mapButton) updateButton(mapButton);
    }

    const currSlide = lightbox.pswp.currSlide;
    if (!currSlide.data.exif.gps || currSlide.data.exif.gps === 'N/A') {
      state.isMapView = false;

      const overlayDiv = document.getElementById('map-overlay');
      if (overlayDiv) overlayDiv.remove();

      toggleShowHideButton(false);
    }

    
  });
};